import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import IconTooltip from './IconTooltip'
import { AIChatAgentIcons } from '../../helpers/iconHelpers'
import { getTimezoneLabel } from '../../helpers/timeDisplaySettings'

const ViewingInTimezone = ({ timeZone }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'eventsPage.viewingInTimezone' })

	const getLabel = () => {
		if (timeZone === 'device') {
			return t('labelDeviceLocalTime')
		}

		return timeZone ? getTimezoneLabel(timeZone) : t('labelUserLocalTime')
	}

	const label = getLabel()

	return (
		<div className="viewing-in-timezone">
			<span className="viewing-in-timezone-label">
				<span className="viewing-in-timezone-icon">
					<AIChatAgentIcons.ClockIcon />
				</span>
				<span>{t('titleViewingIn')}:</span>
			</span>
			<span className="viewing-in-timezone-value">
				<span className="timezone-abbr">{label}</span>
				<IconTooltip description={t('description')} id="viewing-in-timezone-tooltip" placement="bottom" />
			</span>
		</div>
	)
}

ViewingInTimezone.propTypes = {
	timeZone: PropTypes.string,
}

export default ViewingInTimezone
